import { Routes } from '@angular/router';

import { authGuard } from '@core/guard';
import { MarketingLayoutComponent } from '@layout/marketing-layout/marketing-layout.component';

export const routes: Routes = [
  {
    path: '',
    component: MarketingLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('@module/home').then((m) => m.routes),
      },
      {
        path: '',
        loadChildren: () => import('@module/info').then((m) => m.routes),
      },
      {
        path: 'auth',
        canMatch: [authGuard({ requiresAuthentication: false })],
        loadChildren: () => import('@module/auth').then((m) => m.routes),
      },
      {
        path: 'register',
        canMatch: [authGuard({ requiresAuthentication: false })],
        loadChildren: () => import('@module/register').then((m) => m.routes),
      },
      {
        path: 'settings',
        canMatch: [authGuard({ requiresAuthentication: true })],
        loadChildren: () => import('@module/settings').then((m) => m.routes),
      },
      {
        path: 'products',
        canMatch: [authGuard({ requiresAuthentication: true })],
        loadChildren: () => import('@module/products').then((m) => m.routes),
      },
      {
        path: 'favorites',
        canMatch: [authGuard({ requiresAuthentication: true })],
        loadChildren: () => import('@module/favorites').then((m) => m.routes),
      },
      {
        path: 'quotes',
        canMatch: [authGuard({ requiresAuthentication: true })],
        loadChildren: () => import('@module/quotes').then((m) => m.routes),
      },
    ],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
